import Offcanvas from 'react-bootstrap/Offcanvas';
import { useContext } from './Context';

import { useTranslation } from 'react-i18next';
import OrgInfo from './OrgInfo.js'


function OffCanvasExample({ orgs:{data}, ...props }) {
  const { i18n: { language} } = useTranslation();
  const {map: {handleClose, selected, showInfo,hideInfo},} = useContext() 
  const filteredOrgs = data.filter((d) => {
      return d.countyID === selected?.properties.COUNTY || d.countyID === 'N/A'
  })
  const orgsComponent = filteredOrgs.map((org, i)=><OrgInfo id={org.name} {...org}/>)
  return (
    <>
      <Offcanvas show={showInfo}  onHide={hideInfo} onExited={handleClose}   {...props}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{language === 'ua' ? selected?.properties.COUNTY_UA : selected?.properties.COUNTY} 
            </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body >
          {orgsComponent}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default function InfoPanel({...props}) {

  return (
    <>
      <OffCanvasExample key={'end'} backdrop={false} placement={'start'} name={'end'} {...props}/>
    </>
  );
}
